export const page_not_found_style = {
  bodyContentSx: {
    width: {
      xl: 403,
      lg: 403,
      md: 403,
      sm: 300,
      xs: 300,
    },
    textAlign: 'center',
  },
  buttonSx: {
    textTransform: 'none',
    width: {
      md: '100px',
      lg: '100px',
      xl: '100px',
      sm: '100px',
      xs: '100%',
    },
  },
  headerTextSx: {
    fontSize: {
      xs: 20,
      sm: 20,
      md: 28,
      lg: 28,
      xl: 28,
    },
    fontWeight: 600,
  },
  imageBoxSx: {
    zoom: {
      xs: '70%',
      sm: '70%',
      lg: '110%',
      xl: '110%',
      md: '100%',
    },
  },
  bodyContentTextSx: {
    fontSize: {
      xl: 12,
      lg: 12,
      xs: 14,
      sm: 14,
      md: 12,
    },
    fontWeight: 500,
    color: '#0F0B117A',
  },
  footerSx: {
    p: 3,
    position: 'fixed',
    bottom: 0,
    zIndex: '1000',
    left: 0,
    right: 0,
    width: '100%',
    maxWidth: {
      sm: 425,
    },
    mx: {
      sm: 'auto',
    },
    boxSizing: 'border-box',
    bgcolor: 'common.white',
    borderTop: '1.5px dashed',
    borderColor: 'border.main',
    boxShadow: '0px -5px 10px #0000000A',
  },
};
